import { render, staticRenderFns } from "./alarmType.vue?vue&type=template&id=3490e30a&"
import script from "./alarmType.vue?vue&type=script&lang=js&"
export * from "./alarmType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports